module.exports = require("@babel/runtime/helpers/createSuper");;